import type { NoyoPlanMember } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'

function memberKey(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ')
}

function surecoEmployee(members: NoyoPlanMember[]): NoyoPlanMember | undefined {
  const withKey = members.filter(
    (member) =>
      typeof member.employeePublicKey === 'string' &&
      member.employeePublicKey.length > 0
  )
  if (withKey.length > 0) {
    return withKey[0]
  }
  if (members.length === 1) {
    return members[0]
  }
  return undefined
}

function matchingNoyoEmployee(
  noyoMembers: NoyoPlanMember[],
  sureco: NoyoPlanMember | undefined,
  surecoMemberCount: number
): NoyoPlanMember | undefined {
  if (sureco != null) {
    const key = memberKey(sureco.name)
    const matches = noyoMembers.filter(
      (member) => memberKey(member.name) === key
    )
    if (matches.length > 0) {
      return matches[0]
    }
  }
  if (noyoMembers.length === 1 && surecoMemberCount === 1) {
    return noyoMembers[0]
  }
  return undefined
}

export function surecoActiveWhileNoyoTerminated(
  surecoMembers: NoyoPlanMember[] | undefined,
  noyoMembers: NoyoPlanMember[] | undefined
): boolean {
  if (!Array.isArray(surecoMembers) || !Array.isArray(noyoMembers)) {
    return false
  }
  if (surecoMembers.length === 0 || noyoMembers.length === 0) {
    return false
  }

  const surecoByName = new Map<string, NoyoPlanMember[]>()
  for (const member of surecoMembers) {
    const key = memberKey(member.name)
    if (key.length === 0) {
      continue
    }
    const current = surecoByName.get(key) ?? []
    current.push(member)
    surecoByName.set(key, current)
  }

  for (const noyo of noyoMembers) {
    if (noyo.isTerminated !== true) {
      continue
    }
    const matches = surecoByName.get(memberKey(noyo.name)) ?? []
    if (matches.some((sureco) => sureco.isTerminated !== true)) {
      return true
    }
  }

  if (surecoMembers.length === 1 && noyoMembers.length === 1) {
    return (
      surecoMembers[0].isTerminated !== true &&
      noyoMembers[0].isTerminated === true
    )
  }

  return false
}

export function bothEmployeesTerminated(
  surecoMembers: NoyoPlanMember[] | undefined,
  noyoMembers: NoyoPlanMember[] | undefined
): boolean {
  if (!Array.isArray(surecoMembers) || !Array.isArray(noyoMembers)) {
    return false
  }
  if (surecoMembers.length === 0 || noyoMembers.length === 0) {
    return false
  }

  const sureco = surecoEmployee(surecoMembers)
  const noyo = matchingNoyoEmployee(noyoMembers, sureco, surecoMembers.length)
  if (sureco == null || noyo == null) {
    return false
  }
  return sureco.isTerminated === true && noyo.isTerminated === true
}
